export const nameMatch = (receivedName: string, names: string[]) => {
  const matchs = names.filter((name) => `${receivedName}`.toLowerCase().split(' ').includes(name));

  return matchs.length === names.length;
};
